import { render, staticRenderFns } from "./TableWlTreatments.vue?vue&type=template&id=6ed12a0a"
import script from "./TableWlTreatments.vue?vue&type=script&lang=js"
export * from "./TableWlTreatments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports